export default "__VITE_ASSET__Drx0$9V4__"